import { render } from "./FaceIdResult.vue?vue&type=template&id=0311d3fd&scoped=true"
import script from "./FaceIdResult.vue?vue&type=script&lang=js"
export * from "./FaceIdResult.vue?vue&type=script&lang=js"

import "./FaceIdResult.vue?vue&type=style&index=0&id=0311d3fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0311d3fd"]])

export default __exports__